import { IRegisterUser } from './auth';

export interface ISelect {
    id: string | number;
    code?: string;
    name: string;
    extra?: string;
    parent?: ISelect;
    valueSmart?: string;
    isFraud?: boolean;
}

export enum ParamEnum {
    DOCUMENT_TYPE = 'DOCUMENT_TYPE',
    GENDER = 'GENDER',
    PERSON_TYPE = 'PERSON_TYPE',
    CONTACT_PERSON_TYPE = 'CONTACT_PERSON_TYPE',
    ADDRESS_TYPE = 'ADDRESS_TYPE',
    ORBIT_PREFERRED_CONTACT_METHOD = 'ORBIT_PREFERRED_CONTACT_METHOD',
    ORBIT_ADDRESS_TYPE = 'ORBIT_ADDRESS_TYPE',
    SPECIAL_CONDITION = 'SPECIAL_CONDITION',
    CONTACT_TYPE = 'CONTACT_TYPE',

    PQRWEB = 'PQRWEB',
    PQR_BRANCH = 'PQR_BRANCH',
    PQR_RECEPTION_CHANNEL = 'PQR_RECEPTION_CHANNEL',
    PQR_TYPE = 'PQR_TYPE',
    PQR_HALF = 'PQR_HALF',
    PQR_SUBTYPE_DP = 'PQR_SUBTYPE_DP',
    PQR_PROCEDURE = 'PQR_PROCEDURE',
    PQR_COMPLIANCE_TERMS = 'PQR_COMPLIANCE_TERMS',

    PQR_CHANNEL_PRESENTS_FAILURE = 'PQR_CHANNEL_PRESENTS_FAILURE',
    PQR_CONTROL_ENTITY = 'PQR_CONTROL_ENTITY',
    PQR_DESISTD = 'PQR_DESISTD',
    PQR_RECEPTION_INSTANCE = 'PQR_RECEPTION_INSTANCE',
    PQR_RECEPTION_POINT = 'PQR_RECEPTION_POINT',
    PQR_MARKING = 'PQR_MARKING',
    PQR_MARKING_PROCEDURE = 'PQR_MARKING_PROCEDURE',
    PQR_ADMISSION = 'PQR_ADMISSION',
    PQR_ACCEPTANCE = 'PQR_ACCEPTANCE',
    PQR_RECTIFICATION = 'PQR_RECTIFICATION',
    PQR_FRAUD_TYPE = 'PQR_FRAUD_TYPE',
    PQR_FRAUD_MODE = 'PQR_FRAUD_MODE',

    PQR_MOTIVE = 'PQR_MOTIVE',
    PQR_SUBMOTIVE1 = 'PQR_SUBMOTIVE1',
    PQR_SUBMOTIVE2 = 'PQR_SUBMOTIVE2',
    PQR_SUBMOTIVE3 = 'PQR_SUBMOTIVE3',
    PQR_SUBMOTIVE4 = 'PQR_SUBMOTIVE4',

    PQR_EDIT_AMP = 'PQR_EDIT_AMP',
    PQR_EDIT_PRO = 'PQR_EDIT_PRO',
    PQR_EDIT_SOL = 'PQR_EDIT_SOL',

    PQR_STATUS = 'PQR_STATUS',

    PQR_REPLICA = 'PQR_REPLICA',

    PQR_REDIRECTION_AREA = 'PQR_REDIRECTION_AREA',
    PQR_REDIRECTION_PERSON = 'PQR_REDIRECTION_PERSON',

    ALERTS_STATUS = 'ALERTS_STATUS',
    ALERTS_RECEPTION_CHANNEL = 'ALERTS_RECEPTION_CHANNEL',
    ALERTS_TYPE_PQR = 'ALERTS_TYPE_PQR',
    ALERTS_RECEIVED_THROUGH = 'ALERTS_RECEIVED_THROUGH',
    ALERTS_SUBTYPE_DP = 'ALERTS_SUBTYPE_DP',
    ALERTS_TRANSACTION = 'ALERTS_TRANSACTION',
    ALERTS_ALERT_DATE = 'ALERTS_ALERT_DATE',
    ALERTS_CLASSIFICATION = 'ALERTS_CLASSIFICATION',

    PQR_IN_FAVOR_OF = 'PQR_IN_FAVOR_OF',
    PQR_IN_FAVOR_OF_SMART = 'PQR_IN_FAVOR_OF_SMART',

    PQR_FINAL_CAUSALITY = 'PQR_FINAL_CAUSALITY',
    PQR_FINAL_CAUSALITY_MOTIVE = 'PQR_FINAL_CAUSALITY_MOTIVE',
    PQR_FINAL_CAUSALITY_PROTECTION = 'PQR_FINAL_CAUSALITY_PROTECTION',

    PQR_RESPONSE_MEDIUM = 'PQR_RESPONSE_MEDIUM',

    PQR_CLOSING_COMPLIANCE_TERMS = 'PQR_CLOSING_COMPLIANCE_TERMS',
    PQR_CLOSING_NON_COMPLIANCE_REASON = 'PQR_CLOSING_NON_COMPLIANCE_REASON',

    INCHARGE = 'INCHARGE',

    SARLAFT_STATUS_VALIDATION = 'SARLAFT_STATUS_VALIDATION',
    SARLAFT_FILTER_VALIDATION = 'SARLAFT_FILTER_VALIDATION',
    SARLAFT_CHANNEL = 'SARLAFT_CHANNEL',
    SARLAFT_TYPIFICATION = 'SARLAFT_TYPIFICATION',
    SARLAFT_TYPIFICATION2 = 'SARLAFT_TYPIFICATION2',
    SARLAFT_STATUS = 'SARLAFT_STATUS',

    CASES_GENERAL_INFORMATION_CHANNEL = 'CASES_GENERAL_INFORMATION_CHANNEL',
    CASES_GENERAL_INFORMATION_TYPIFICATION1 = 'CASES_GENERAL_INFORMATION_TYPIFICATION1',
    CASES_GENERAL_INFORMATION_TYPIFICATION2 = 'CASES_GENERAL_INFORMATION_TYPIFICATION2',
    CASES_GENERAL_INFORMATION_TYPIFICATION3 = 'CASES_GENERAL_INFORMATION_TYPIFICATION3',
    CASES_GENERAL_INFORMATION_TYPIFICATION4 = 'CASES_GENERAL_INFORMATION_TYPIFICATION4',
    CASES_GENERAL_INFORMATION_TYPIFICATION5 = 'CASES_GENERAL_INFORMATION_TYPIFICATION5',

    QUOTATION_TYPE = 'QUOTATION_TYPE',
    QUOTATION_BOUQUET = 'QUOTATION_BOUQUET',
    QUOTATION_TYPIFICATION = 'QUOTATION_TYPIFICATION',
    QUOTATION_STATUS = 'QUOTATION_STATUS',
    QUOTATION_SUBTYPIFICATION = 'QUOTATION_SUBTYPIFICATION',
    QUOTATION_STAGES = 'QUOTATION_STAGES',
    QUOTATION_MOTIVES = 'QUOTATION_MOTIVES',
    //Templates
    QUOTATION_AUTOMOBILES = 'QUOTATION_AUTOMOBILES',
    QUOTATION_AUTOMOBILES_HEAVYWEIGHT = 'QUOTATION_AUTOMOBILES_HEAVYWEIGHT',
    QUOTATION_AUTOMOBILES_LIGHTWEIGHT = 'QUOTATION_AUTOMOBILES_LIGHTWEIGHT',
    QUOTATION_MEDICAL_CIVIL_RESPONSIBILITY = 'QUOTATION_MEDICAL_CIVIL_RESPONSIBILITY',
    QUOTATION_PREVI = 'QUOTATION_PREVI',
    QUOTATION_PREVI_HOME = 'QUOTATION_PREVI_HOME',
    QUOTATION_PREVI_COMMON_AREAS = 'QUOTATION_PREVI_COMMON_AREAS',
    QUOTATION_PREVI_GOODS_TRANSPORT = 'QUOTATION_PREVI_GOODS_TRANSPORT',

    TYPE_ENTAILMENT = 'TYPE_ENTAILMENT',
    POLICY_HOLDER_INSURED = 'POLICY_HOLDER_INSURED',
    POLICY_HOLDER_BENEFICIARY = 'POLICY_HOLDER_BENEFICIARY',
    INSURED_BENEFICIARY = 'INSURED_BENEFICIARY',
    TYPE_CLIENT = 'TYPE_CLIENT',
    WIELDS_POLITICAL_POWER = 'WIELDS_POLITICAL_POWER',
    GENERAL_PUBLIC_RECOGNITION = 'GENERAL_PUBLIC_RECOGNITION',
    PUBLICLY_EXPOSED_PERSON = 'PUBLICLY_EXPOSED_PERSON',
    TAXES_OTHER_COUNTRIES = 'TAXES_OTHER_COUNTRIES',
    FOREIGN_CURRENCY_TRANSACTIONS = 'FOREIGN_CURRENCY_TRANSACTIONS',
    FINANCIAL_PRODUCTS_ABROAD = 'FINANCIAL_PRODUCTS_ABROAD',
    FOREIGN_CURRENCY_ACCOUNTS = 'FOREIGN_CURRENCY_ACCOUNTS',
    COMPLAINTS_LAST_TWO_YEARS = 'COMPLAINTS_LAST_TWO_YEARS',
    LAST_YEAR_TAX_RETURN = 'LAST_YEAR_TAX_RETURN',

    JUDICIAL_STATUS = 'JUDICIAL_STATUS',
    JUDICIAL_TYPE_PROCESSES = 'JUDICIAL_TYPE_PROCESSES',
    JUDICIAL_SENDER_ENTITIES = 'JUDICIAL_SENDER_ENTITIES',
    JUDICIAL_TYPE_ISSUES = 'JUDICIAL_TYPE_ISSUES',
    TYPE_COMPENSATION = 'TYPE_COMPENSATION',
    TYPE_COMPLAINT = 'TYPE_COMPLAINT',

    SWITCH_TYPIFICATION1 = 'SWITCH_TYPIFICATION1',
    SWITCH_TYPIFICATION2 = 'SWITCH_TYPIFICATION2',

    SFC_CAPTURE_UNIT = 'SFC_CAPTURE_UNIT',
    SFC_CAPTURE_UNIT_NEW = 'SFC_CAPTURE_UNIT_NEW',

    TECHNICAL_BRANCH = 'TECHNICAL_BRANCH',
    UNIFIED_PRODUCT = 'UNIFIED_PRODUCT',
    TYPE_MOTIVE = 'TYPE_MOTIVE',
    BASE_DATE_FOR_DAY_CALCULATION = 'BASE_DATE_FOR_DAY_CALCULATION',
    TYPE_DATE_PQR_TIMES = 'TYPE_DATE_PQR_TIMES',
    TYPE_DATE_PQR_RULE_STATUS = 'TYPE_DATE_PQR_RULE_STATUS',

    FUNCTIONARIES_SWITCHBOARD_AREA = 'FUNCTIONARIES_SWITCHBOARD_AREA',
    FUNCTIONARIES_SWITCHBOARD_POSITION = 'FUNCTIONARIES_SWITCHBOARD_POSITION',
    PERSON_TYPE_NAT = 'PERSON_TYPE_NAT',

    SWITCH_FUNCTIONARY_ATENDED_CALL = 'SWITCH_FUNCTIONARY_ATENDED_CALL',
}

export enum SmartSupervisionEnum {
    MOMENT1_GET_ACK_FILES = 'MOMENT1_GET_ACK_FILES',
    MOMENT1_POST_ACK = 'MOMENT1_POST_ACK',
    MOMENT2_POST_COMPLAINT = 'MOMENT2_POST_COMPLAINT',
    MOMENT2_POST_STORAGE = 'MOMENT2_POST_STORAGE',
    MOMENT3_POST_COMPLAINT = 'MOMENT3_POST_COMPLAINT',
    MOMENT3_POST_STORAGE = 'MOMENT3_POST_STORAGE',
    MOMENT4_UPDATE = 'MOMENT4_UPDATE',
    MOMENT4_ACCOUNT = 'MOMENT4_ACCOUNT',
    SAMPLE = 'SAMPLE',
}

export const PERSON_TYPE_JURIDICAL = `${ParamEnum.PERSON_TYPE}_JUR`;

export interface Attachment {
    id?: string;
    name: string;
    extension?: string;
    base64?: string;
    url?: string;
    createdBy?: IRegisterUser;
    created_at?: Date;
}

export interface Product {
    id?: string;
    code?: string;
    name?: string;
    applyPqr?: boolean;
    applyEscalations?: boolean;
    sfcCaptureUnit?: ISelect | string;
    sfcCaptureUnitNew?: ISelect | string;
    active?: boolean;
    description?: string;
    technicalBranch?: ISelect | string;
    unifiedProduct?: ISelect | string;
}

export interface ResponseData {
    deliveryId?: string;
    message?: string;
    statusCode?: number | string;
    status?: number | string;
}

export interface ActionButtonGroupProps {
    id?: string;
    buttonCreate?: buttonProps;
    buttonSearch?: buttonProps;
    buttonUpdate?: buttonProps;
    buttonView?: buttonProps;
    buttonLog?: buttonProps;
    onHistoricalShow?: (show: boolean) => void;
    extraParam?: unknown;
}

export interface buttonProps {
    show?: boolean;
    route?: string;
}

export interface Historical {
    id: string;
    previousState?: object;
    changes?: ChangeElement[];
    created_at?: Date;
    createdBy?: IRegisterUser;
    paramId?: string;
    elementos: any;
}

export interface ChangeElement {
    field?: string;
    oldValue?: any;
    newValue?: any;
}

export enum SkillBpEnum {
    INFORMACION_GENERAL = 'GENERAL',
    CONMUTADOR = 'CONMUTADOR',
    SARLAFT = 'SARLAFT',
}

export enum ChannelBpEnum {
    APP = 'APP',
    CHAT = 'CHAT',
    CHAT_BOT = 'CHAT_BOT',
    TELEFONIA = 'TELEFONIA',
}
